import {useState} from 'react';

export const useDeleteModal = (
  deleteMedia: (id: number) => void,
  setIsDeleteModalOpen: (isOpen: boolean) => void
) => {
  const [deletingId, setDeletingId] = useState<number | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const onDelete = (id: number) => {
    setDeletingId(id);
    setIsDeleteModalOpen(true);
    setShowDeleteModal(true);
  };

  const onCancel = () => {
    setDeletingId(null);
    setIsDeleteModalOpen(false);
    setShowDeleteModal(false);
  };

  const onConfirmDelete = () => {
    if (deletingId) {
      deleteMedia(deletingId);
    }
    onCancel();
  };

  return {
    deletingId,
    showDeleteModal,
    onDelete,
    onConfirmDelete,
    onCancel,
  };
};
